// src/api/statistiquesApi.js
import axios from 'axios';

// URL de base de ton API (à adapter selon ton environnement)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Récupère les statistiques de facturation depuis l'API.
 * @param {Object} params - Paramètres optionnels pour filtrer les statistiques (ex: { annee: 2025, type: 'vente' }).
 * @returns {Promise<Object>} Objet contenant les statistiques.
 */
export const fetchStatistiquesFacturation = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/statistiques-facturation`, { params });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des statistiques de facturation :", error);
    throw new Error("Impossible de charger les statistiques.");
  }
};
